document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.blu-product-detail--tincture .product__description').forEach((description) => {
    const normalize = (value) => value.replace(/\s+/g, ' ').trim();
    const usageHeading = /^(directions?|suggested use|how to use)\s*:?$/i;
    const usageCopy = /^(directions?|suggested use|how to use)\s*[:\-]|^shake well before use\b|^take\s+(?:two|three|2|3)/i;
    const fdaCopy = /(?:not been evaluated by the food and drug administration|not intended to diagnose, treat, cure, or prevent any disease)/i;
    const safetyCopy = /^(?:cautions?|safety|warning)\s*:|^use caution\b/i;
    const safetyDetails = [];

    description.querySelectorAll('h1, h2, h3, h4, h5, h6, strong').forEach((heading) => {
      if (!usageHeading.test(normalize(heading.textContent))) return;
      if (/^H[1-6]$/.test(heading.tagName)) {
        let sibling = heading.nextElementSibling;
        while (sibling && !/^H[1-6]$/.test(sibling.tagName)) {
          const next = sibling.nextElementSibling;
          sibling.remove();
          sibling = next;
        }
      }
      heading.remove();
    });

    description.querySelectorAll('p, li, div').forEach((element) => {
      const text = normalize(element.textContent);
      if ((element.matches('p, li') || element.children.length === 0) && safetyCopy.test(text)) {
        const detail = text
          .replace(/^(?:cautions?|safety|warning)\s*:\s*/i, '')
          .replace(/^use caution while\s+/i, 'Avoid ')
          .replace(/^use caution\s+/i, '')
          .trim();
        if (detail) safetyDetails.push(detail);
        element.remove();
        return;
      }
      if (element.children.length > 0) return;
      if (usageCopy.test(text) || fdaCopy.test(text)) element.remove();
    });

    const walker = document.createTreeWalker(description, NodeFilter.SHOW_TEXT);
    const directTextNodes = [];
    while (walker.nextNode()) directTextNodes.push(walker.currentNode);
    directTextNodes.forEach((node) => {
      const text = normalize(node.textContent);
      if (fdaCopy.test(text)) node.textContent = '';
    });

    if (safetyDetails.length) {
      const notice = description.closest('.blu-product-detail--tincture')?.querySelector('.blu-fda-notice');
      if (notice) {
        const additionalSafety = document.createElement('div');
        additionalSafety.className = 'blu-product-specific-safety';
        const heading = document.createElement('strong');
        heading.textContent = 'Additional safety: ';
        additionalSafety.append(heading, document.createTextNode([...new Set(safetyDetails)].join(' ')));
        notice.prepend(additionalSafety);
      }
    }
  });
});
